import { format } from 'date-fns';
import { TeacherIcon } from 'morpheus-ui';
import { Icon } from '../../atoms/Icon';
import { Tag } from '../../atoms/Tag';
import { EventInfoList, infoItem } from '../../molecules/EventInfoList';
import { Typography } from '../../molecules/Typography';

interface iEventDetails {
  thumbnailUrl: string;
  tags: string[];
  title: string;
  startDate: Date;
  endDate: Date;
  teacherName?: string;
  description: string;
}

interface iEventDetailsProps {
  className?: string;
  footer?: React.ReactNode;
  event?: iEventDetails;
}

function EventDetails({
  event,
  footer,
  className,
}: iEventDetailsProps) {
  if (!event) {
    return null;
  }

  const startDateFormatted = format(event.startDate, 'dd/MM');
  const startTime = format(event.startDate, 'HH:mm');
  const endTime = format(event.endDate, 'HH:mm');

  const infos = [
    {
      icon: {
        Icon: 'calendar_month',
        type: 'material',
      },
      textWeight: 'bold',
      text: startDateFormatted,
    },
    {
      icon: {
        Icon: 'access_time',
        type: 'material',
      },
      textWeight: 'bold',
      text: `${startTime} - ${endTime}`,
    },
  ] as infoItem[];

  if (event.teacherName) {
    infos.push({
      icon: {
        Icon: TeacherIcon,
        type: 'svg',
        className: 'h-6',
      },
      textWeight: 'bold',
      text: `Prof. ${event.teacherName}`,
    });
  }

  return (
    <div className={`flex flex-col gap-xl ${className ?? ''}`}>
      <div className='flex gap-2 items-center lg:gap-xl'>
        {event.thumbnailUrl && (
          <img
            src={event.thumbnailUrl}
            alt={event.title}
            className='h-[85px] w-[150px] rounded-md'
          />
        )}
        <div className='flex flex-col gap-sm h-full'>
          {event.tags.length > 0 && <div className='flex gap-md'>
            {event.tags.map((tag, index) => (
              <Tag variant='neutral' key={index}>
                {tag}
              </Tag>
            ))}
          </div>}
          <Typography type='title' size='h3' className='line-clamp-2'>
            {event.title}
          </Typography>
        </div>
      </div>
      <div className='flex flex-col gap-xxl'>
        <EventInfoList items={infos} />

        <div className='flex gap-sm'>
          <Icon
            Icon={'info'}
            type='material'
            className='text-mono-color-darkest'
          />
          <Typography showViewMoreButton viewMoreMaxTextLength={180}>
            {event.description}
          </Typography>
        </div>

        <span className='border-b-hairline border-b-mono-color-light' />
      </div>
      {footer}
    </div>
  );
}

export { EventDetails };
export type { iEventDetails };

